var map = {
	"./config.development.ts": 350,
	"./config.production.ts": 351,
	"./config.qa.ts": 352,
	"./config.staging.ts": 353
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;


//////////////////
// WEBPACK FOOTER
// ./ClientApp ^\.\/config\..*\.ts$
// module id = 46
// module chunks = 0